/**
 * A modal window's focus (slice 6b fix round): an open `Menu` or `Dialogue`
 * takes the keyboard focus (its one focusable element), keeps it (the window
 * turns Tab away: nothing behind it is reachable), and gives it back to what
 * had it when it closes, if that is still on the page and nothing else took
 * the focus meanwhile.
 */
import { type RefObject, useEffect } from 'react';

export const useModalFocus = (target: RefObject<HTMLElement | null>): void => {
  useEffect(() => {
    const el = target.current;
    const before = document.activeElement;
    el?.focus({ preventScroll: true });
    return () => {
      const now = document.activeElement;
      const lost = now === null || now === document.body || (el !== null && el.contains(now));
      if (lost && before instanceof HTMLElement && before !== el && before.isConnected) before.focus({ preventScroll: true });
    };
  }, [target]);
};
